// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import queryString from 'query-string';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

//** get Salary Consolidation api
export const getConsolidation = createAsyncThunk('getAllConsolidationData/getConsolidation', async (data) => {
    const query = queryString.stringify(data);
    try {
        let response = await axios.get('/Salary/consolidation-report?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        let temp = JSON.parse(response.data);

        return Promise.resolve(temp);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const consolidationSlice = createSlice({
    name: 'getAllConsolidationData',

    initialState: {
        consolidation: []
    },
    reducers: {
        removeConsolidation: (state) => {
            state.consolidation = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getConsolidation.fulfilled, (state, action) => {
            state.consolidation = action?.payload;
            return;
        });
    }
});

export const { removeConsolidation } = consolidationSlice.actions;
export default consolidationSlice.reducer;
